import { selectGraphHasContent } from 'components/Graph/model/selectors/selectGraphHasContent';
import { not } from 'fp-ts/lib/function';

export const selectGraphToolbarDisabled = not(selectGraphHasContent);
